import { SurveyAnalyticsEvent } from "./analytics/SurveyAnalyticsEvent";
import { SurveyResponse } from "./SurveyResponse";

export class SurveyResponseWrapper {
    public constructor(
        public surveyResponse: SurveyResponse,
        public surveyAnalyticsEvents: SurveyAnalyticsEvent[]) {
    }
 }
